import script from "./serviceview.vue?vue&type=script&setup=true&lang=js"
export * from "./serviceview.vue?vue&type=script&setup=true&lang=js"

import "./serviceview.vue?vue&type=style&index=0&id=4cda9bfa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cda9bfa"]])

export default __exports__